module.exports = __webpack_public_path__ + "static/theChain-hero-cbfa7db91be1907bfb3bf429889239df.jpg";